import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {AlertService, AuthenticationService, ClientProfileService, TenantService, UserService} from './_services/';
import {InactivityMessageComponent} from './components/inactivityMessage/index';
import {LoginHelper} from './helpers';
import {Constants} from "./helpers/constants";
import {MatDialog} from "@angular/material/dialog";
import {filter, map} from "rxjs/operators";
import {LogService} from "./_services/log.service";
import {ThemePaletteService} from "./core/services/theme-palette.service";
import {LogoutHubService} from "./_services/signalr/logoutHub.service";


export const ROOT_SELECTOR = 'app';


/**
 * App Component
 * Top Level Component
 */
@Component({
    standalone: false,
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
  private secondTimeoutId: any;
  private secondTimeoutDuration = window.location.hostname == 'localhost' ? 1440 : 3;
  inactivity = window.location.hostname == 'localhost' ? 1440 : 3;
  settings: any;
  masterSettings: any;
  clientLogo: string;
  consultantLogo: string;
  isLoggedIn: boolean = false;

  constructor(public location: Location,
              public authenticationService: AuthenticationService,
              public alertService: AlertService,
              public dialog: MatDialog,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private logService: LogService,
              private clientProfileService: ClientProfileService,
              private userService: UserService,
              private themePalette: ThemePaletteService,
              private logoutHubService: LogoutHubService) {
    this.authenticationService.isLoggedIn.subscribe((value) => {
      this.isLoggedIn = value;
      this.updateSettings();
    });
    this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.logService.logNavigate((<NavigationEnd>e).urlAfterRedirects).subscribe();
      }
    });
  }

  public ngOnInit() {
    this.logoutHubService.startConnection();
    if ((self.parent && self.parent !== self)
      && (self.parent.frames.length != 0)) {
      self.parent.location.href = document.location.href;
    }
    this.clientProfileService.getMasterPublicSettings().subscribe((data: any) => {
      this.masterSettings = data;
    });
    this.updateSettings();
    this.consultantLogo = '../assets/img/logo_light1.png';

    setInterval(() => {
      const panel = document.getElementsByClassName('above-all');
      if (panel.length > 0) {
        (<any>(panel[0])).parentNode.parentNode.style.zIndex = 1000000;
      }
    }, 1000);

    if (LoginHelper.getTenantName() !== Constants.RiskSpongeMaster) {
      this.userService.getPublicManagers(LoginHelper.getTenantName()).subscribe(managersInfo => {
        this.setLogos((managersInfo.clientCompany || {}).logoFileName, (managersInfo.consultantCompany || {}).logoFileName);
      });
      this.userService.accountUpdated.subscribe(u => {
        this.setLogos((u.clientCompany || {}).logoFileName, (u.consultantCompany || {}).logoFileName);
      });
    }
  }

  updateSettings() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName !== Constants.RiskSpongeMaster) {
      this.userService.getPublicManagers(tenantName).subscribe(managersInfo => {
        this.settings = managersInfo.settings;
        if (this.settings) {
          document.documentElement.style.setProperty('--menu-color', this.settings.menuColor);
          document.documentElement.style.setProperty('--link-color', this.settings.menuFontColor);
          document.documentElement.style.setProperty('--sub-link-color', this.settings.subMenuFontColor);
          this.themePalette.applyFromSettings(this.settings);
          this.setLogos((managersInfo.clientCompany || {}).logoFileName, (managersInfo.consultantCompany || {}).logoFileName);
        }
      });
    } else {
      this.themePalette.applyFromSettings();
    }
  }


  isHeaderActive() {
    const isHeaderActive = this.location.path() != null && this.location.path() != "" && this.location.path().indexOf('trustReport') < 0 && (this.location.path().indexOf('login') < 0 || this.location.path().indexOf('multi-login') >= 0) && window.location.hostname.indexOf('login.') != 0 && !this.authenticationService.isSso();
    return isHeaderActive;
  }

  public handleFirstInactivityCallback() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    let dialogRef = this.dialog.open(InactivityMessageComponent,
      {
        width: '250px',
        panelClass: 'above-all'
      });

    this.secondTimeoutId = setTimeout(() => {
      this.handleSecondInactivityCallback();
    }, this.secondTimeoutDuration * 60 * 1000);

    dialogRef.afterClosed().subscribe(result => {
      clearTimeout(this.secondTimeoutId);
    });
  }

  public handleSecondInactivityCallback() {

    this.alertService.clear();
    this.dialog.closeAll();
    this.authenticationService.logout();
  }


  setLogos(clientLogo: string, consultantLogo: string) {
    this.clientLogo = window.location.origin + '/api/attachments/file?name=' + encodeURIComponent(clientLogo || 'clientlogo.png') + '&path=Account/System/' + '&token=' + LoginHelper.getFileToken();
    this.consultantLogo = consultantLogo ? window.location.origin + '/api/attachments/file?name=' + encodeURIComponent(consultantLogo || 'consultantlogo.png') + '&path=Account/System/' + '&token=' + LoginHelper.getFileToken() : '../assets/img/logo_light1.png';
  }

}
